import { render, staticRenderFns } from "./clone.vue?vue&type=template&id=6ac65c78&scoped=true&"
import script from "./clone.vue?vue&type=script&lang=js&"
export * from "./clone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac65c78",
  null
  
)

export default component.exports